/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type FetchKarteOnUseKarteQueryVariables = Exact<{
  id: string | number;
}>;


export type FetchKarteOnUseKarteQuery = { user: { karte: { id: string, userComment: string, numberOfPlannerComments: number, hasCommentsFromPlannersBelongingToSameBranch: boolean, modifiedAt: TimeString, channel: Types.Channel, ownKartePlannerComment: { comment: string | null } | null, topics: Array<{ id: string, name: string }>, diagnosis: { gender: Types.Gender, livingPrefecture: Types.Prefecture, birthYear: number, saving: number, annualIncome: number, savingMonth: number, monthlyRentCost: number, monthlyInsurance: number, investment: number, loanBalance: number | null, children: Array<{ age: number, gender: Types.Gender }>, partner: { birthYear: number, annualIncome: number } | null, job: { name: string } | null } } | null } };


export const FetchKarteOnUseKarteDocument = gql`
    query FetchKarteOnUseKarte($id: ID!) {
  user(id: $id) {
    karte {
      id
      userComment
      ownKartePlannerComment {
        comment
      }
      numberOfPlannerComments
      topics {
        id
        name
      }
      hasCommentsFromPlannersBelongingToSameBranch
      modifiedAt
      channel
      diagnosis {
        gender
        livingPrefecture
        birthYear
        saving
        annualIncome
        savingMonth
        monthlyRentCost
        children {
          age
          gender
        }
        partner {
          birthYear
          annualIncome
        }
        monthlyInsurance
        investment
        job {
          name
        }
        loanBalance
      }
    }
  }
}
    `;

/**
 * __useFetchKarteOnUseKarteQuery__
 *
 * To run a query within a Vue component, call `useFetchKarteOnUseKarteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKarteOnUseKarteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKarteOnUseKarteQuery({
 *   id: // value for 'id'
 * });
 */
export function useFetchKarteOnUseKarteQuery(variables: FetchKarteOnUseKarteQueryVariables | VueCompositionApi.Ref<FetchKarteOnUseKarteQueryVariables> | ReactiveFunction<FetchKarteOnUseKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>(FetchKarteOnUseKarteDocument, variables, options);
}
export function useFetchKarteOnUseKarteLazyQuery(variables?: FetchKarteOnUseKarteQueryVariables | VueCompositionApi.Ref<FetchKarteOnUseKarteQueryVariables> | ReactiveFunction<FetchKarteOnUseKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>(FetchKarteOnUseKarteDocument, variables, options);
}
export type FetchKarteOnUseKarteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>;